'use strict'

var regexCheck = require('../util/regex-check.js')

var asciiDigit = regexCheck(/\d/)

module.exports = asciiDigit
